/* Forms - Textarea Init */
/* ---------------------------------------------------------------------------------------------------- */
function ipcrimeFormsTextareaInit() {

    /* Loop Inputs */
    jQuery( 'textarea.form-textarea' ).each(function( index ) {
    
        /* Get Input */
        var input = jQuery( this );
        
        /* Template */
        input.wrap( '<div></div>' );
        
        /* Move Classes */
        input.parent().attr( 'class' , input.attr( 'class' ) );
        input.removeClass();

        /* Label */
        ipcrimeFormsStyleLabel( input );
        
        /* Disabled */
        ipcrimeFormsStyleDisabled( input );

    });

}